import React from "react";
import { useTranslation } from "@lib/i18n";
import { func } from "prop-types";

import { Button } from "@components/shared/Button";
import Typography from "@components/shared/Typography";

import { getCarImagePath } from "@shared/v2/lib/getCarImagePath";
import { getStaticAssetURL } from "@lib/getStaticAssetURL";

const ThankYouSectionBanner = ({ onThankYouButtonClick }) => {
  const { t } = useTranslation();

  const imageProps = {
    src: getStaticAssetURL(getCarImagePath("P202")),
    alt: t("testDrive.merciSection.car"),
    title: t("testDrive.merciSection.car"),
  };

  return (
    <div className="flex justify-between items-center border border-greyLight p-4 rounded-md">
      <div className="grow shrink sm:basis-3/5">
        <Typography className="mb-4 font-semibold">
          {t("testDrive.merciSection.highlightedQuestion")}
        </Typography>
        <div className="flex justify-between mb-8">
          <Typography>{t("testDrive.merciSection.text2")}</Typography>
          <div className="block sm:hidden">
            <img className="w-full" {...imageProps} />
          </div>
        </div>
        <div className="flex justify-center">
          <Button
            data-id="thank-you-button-configure-ami"
            onClick={onThankYouButtonClick}
          >
            {t("testDrive.merciSection.buttonText")}
          </Button>
        </div>
      </div>
      <div className="hidden grow shrink basis-2/5 sm:block">
        <img className="w-full" {...imageProps} />
      </div>
    </div>
  );
};

ThankYouSectionBanner.propTypes = {
  onThankYouButtonClick: func.isRequired,
};

export default ThankYouSectionBanner;
